module.exports = __webpack_public_path__ + "static/media/business.aefb0d98.svg";